import { Button } from "@lya-protect/lya-protect-form-library/dist/UI";
import { PropsWithChildren } from "react";
import styles from "./Collapse.module.scss";
import ChevronDown from "@endya-conformite/ui-kit/src/assets/icons/chevron-down.svg?react";
import ChevronUp from "@endya-conformite/ui-kit/src/assets/icons/chevron-up.svg?react";

export function Collapse({
  isOpen,
  title,
  onToggle,
  hasToggleText = true,
  children,
}: PropsWithChildren & {
  isOpen: boolean;
  title: string;
  onToggle: () => void;
  hasToggleText?: boolean
}) {
  const getButtonText = (hasToggleText: boolean, isOpen: boolean) => {
    if (!hasToggleText) return "";
    return isOpen ? "Voir moins" : "Voir plus";
  };

  return (
    <>
      <div className={styles.collapseTitle}>
        <h2>{title}</h2>

        <Button
          variant="text"
          icon={isOpen ? <ChevronUp /> : <ChevronDown />}
          onClick={onToggle}
        >
          {getButtonText(hasToggleText, isOpen)}
        </Button>
      </div>
      {isOpen ? children : null}
    </>
  );
}